webpackJsonp([16],{

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServicioSocialDescargasPage_vue_vue_type_template_id_08efddfa_scoped_true___ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ServicioSocialDescargasPage_vue_vue_type_script_lang_js___ = __webpack_require__(523);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(16);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ServicioSocialDescargasPage_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ServicioSocialDescargasPage_vue_vue_type_template_id_08efddfa_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ServicioSocialDescargasPage_vue_vue_type_template_id_08efddfa_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "08efddfa",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__(229) !== null) && (__webpack_require__(230) !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
    return saveAs;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),

/***/ 229:
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ 230:
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ServicioSocialDescargasPage_vue_vue_type_script_lang_js___ = __webpack_require__(524);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ServicioSocialDescargasPage_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_file_saver__);





function ownKeys(e, r) { var t = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default()(e); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default.a) { var o = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default()(e); r && (o = o.filter(function (r) { return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty___default()(e, r, t[r]); }) : __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default.a ? Object.defineProperties(e, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default()(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(t, r)); }); } return e; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ServicioSocialDescargas',
  data: function data() {
    return {
      cargandoDatos: false,
      items: [],
      documentExist: false,
      generandoPdf: false
    };
  },
  computed: _objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])({
    alumno: function alumno(state) {
      return state.user.profile;
    }
  })), {}, {
    url: function url() {
      return 'https://sii.tuxtla.tecnm.mx/documentos/servicio_social/index.php?noDeControl=' + this.alumno.noDeControl;
      // return 'http://sii.local/documentos/servicio_social/index.php?noDeControl=' + this.alumno.noDeControl
    }
  }),

  methods: {
    checkDocumentExist: function checkDocumentExist() {
      var _this = this;
      this.cargandoDatos = true;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.document, {
        headers: {
          'Authorization': '',
          'Accept': 'application/pdf'
        },
        responseType: 'arraybuffer'
      }).then(function () {
        _this.documentExist = true;
      }).catch(function (error) {
        console.log(error.data);
      }).finally(function () {
        _this.cargandoDatos = false;
      });
    },
    getDocumentos: function getDocumentos() {
      var _this2 = this;
      this.cargandoDatos = true;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.url).then(function (response) {
        _this2.cargandoDatos = false;
        _this2.items = response.data.data;
      });
    },
    downloadFile: function downloadFile(item) {
      var _this3 = this;
      this.generandoPdf = true;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.url + '&action=download&documentId=' + item.id, {
        headers: {
          'Authorization': '',
          'Accept': 'application/pdf'
        },
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this3.generandoPdf = false;
        var blob = new Blob([response.data], {
          type: response.headers['content-type']
        });
        __WEBPACK_IMPORTED_MODULE_7_file_saver___default.a.saveAs(blob, item.documento + '.pdf');
      }).catch(function (error) {
        console.log(error.data);
      }).finally(function () {
        _this3.cargandoDatos = false;
      });
    }
  },
  mounted: function mounted() {
    this.getDocumentos();
  }
});

/***/ }),

/***/ 642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ServicioSocialDescargasPage_vue_vue_type_template_id_08efddfa_scoped_true___ = __webpack_require__(643);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ServicioSocialDescargasPage_vue_vue_type_template_id_08efddfa_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ServicioSocialDescargasPage_vue_vue_type_template_id_08efddfa_scoped_true___["b"]; });


/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{staticClass:"d-flex justify-center"},[_c('v-flex',{attrs:{"md6":""}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Servicio Social - Descargas")])])]),_vm._v(" "),_c('v-card-text',{staticStyle:{"min-height":"200px"}},[(_vm.cargandoDatos)?_c('div',[_c('p',[_vm._v("Cargando datos")]),_vm._v(" "),_c('v-progress-linear',{attrs:{"indeterminate":"","rounded":"","height":"6"}})],1):_vm._e(),_vm._v(" "),(_vm.generandoPdf)?_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":"","rounded":"","height":"6"}})],1):_vm._e(),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.items),function(item){return [_c('v-list-tile',{key:item.id,attrs:{"target":"_blank"},on:{"click":function($event){return _vm.downloadFile(item)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.documento)}})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("\n                    cloud_download\n                  ")])],1)],1)]})],2),_vm._v(" "),(_vm.items.length === 0 && !_vm.cargandoDatos)?_c('v-alert',{attrs:{"value":true,"color":"error","icon":"warning","outline":""}},[_vm._v("\n            No hay ningún documento disponible.\n          ")]):_vm._e()],1)],1)],1)],1)],1)
}
var staticRenderFns = []



/***/ })

});


// WEBPACK FOOTER //
// static/js/16.eaf4b4620cb4653c50e1.js